import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

const getDefaultState = () => {
    return {
        clientId: null,
        clientName: null,
        userId: null,
        signedIn: false,
        devices: null,
        aliases: null,
        deactivatedDevices: null,
        displayDeactivated: false,
        users: null,
        invites: null,
        error: null,
        eshop: true,
      }
  }

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    resetState (state) {
        Object.assign(state, getDefaultState())
      },
    setError: (state, payload) => state.error = payload,
    setUserId: (state, payload) => state.userId = payload,
    setSignedIn(state, payload)
    {
        state.signedIn = payload;
    },
    setClient(state, payload)
    {
        state.devices = null;
        state.aliases = null;
        state.deactivatedDevices = null;
        state.users = null;
        state.invites = null;
        state.error = null;


        state.clientId = payload.clientId;
        state.clientName = payload.clientName;
        
    },
    setClientId(state, payload)
    {
        state.clientId = payload;
        
    },
    setClientName: (state, payload) => state.clientName = payload,
    setDevices(state, payload)
    {
        state.devices = payload;
    },
    setUsers: (state, payload) => state.users = payload,
    setInvites: (state, payload) => state.invites = payload,
    setDeactivatedDevices(state, payload)
    {
        state.deactivatedDevices = payload;
    },
    
    resetDevices(state)
    {
        state.devices = null;
    },
    resetDeactivatedDevices(state)
    {
        state.deactivatedDevices = null;
    },
    setAliases(state, payload)
    {
        state.aliases = payload;
    },
    setDisplayDeactivated(state, displayDeactivated)
    {
        state.displayDeactivated = displayDeactivated;
    }
    
  },
    getters: {
        getDevices: state => state.devices,
        getDeactivatedDevices: state => state.deactivatedDevices,
        signedIn: state => state.signedIn
    },
    plugins: [vuexLocal.plugin]
})